import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'component-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modals.component.css']
})
export class ModalConfirmComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
